import WaterColor from "images/png/promo-card-img/promo-card-designs/watercolor.png";
import Abstract from "images/png/promo-card-img/promo-card-designs/abstract.png";
import Confetti from "images/png/promo-card-img/promo-card-designs/confetti.png";
import Halftone from "images/png/promo-card-img/promo-card-designs/halftone.png";
import RedSquares from "images/png/promo-card-img/promo-card-designs/red-square.png";
import Ornament from "images/png/promo-card-img/promo-card-designs/ornament.png";
import Grunge from "images/png/promo-card-img/promo-card-designs/grunge.png";
import Organic from "images/png/promo-card-img/promo-card-designs/organic.png";
import Textured from "images/png/promo-card-img/promo-card-designs/textured.png";

export const PromoCardData = [
  { cardImage: WaterColor, cardName: "Watercolor" },
  { cardImage: Abstract, cardName: "Abstract" },
  { cardImage: Confetti, cardName: "Confetti" },
  { cardImage: Halftone, cardName: "Halftone" },
  { cardImage: RedSquares, cardName: "Red Squares" },
  { cardImage: Ornament, cardName: "Ornament" },
  { cardImage: Grunge, cardName: "Grunge", variant: true },
  { cardImage: Organic, cardName: "Organic", variant: true },
  { cardImage: Textured, cardName: "Textured", variant: true }
];
